import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_NAME } from '../shared/app_config';
import logo from '../assets/logo.svg';
import { typography } from '~/theme';

interface AppHeaderProps {
  subtitle?: string;
  size?: 'small' | 'medium' | 'large';
  light?: boolean;
}

const sizes = {
  small:  { logo: 28, name: 'body1'  as const, sub: 'caption'  as const, gap: 1 },
  medium: { logo: 36, name: 'h6'     as const, sub: 'body2'    as const, gap: 1.5 },
  large:  { logo: 48, name: 'h5'     as const, sub: 'body1'    as const, gap: 2 },
};

const AppHeader: React.FC<AppHeaderProps> = ({ subtitle, size = 'medium', light = false }) => {
  const s = sizes[size];
  const textColor = light ? '#fff' : 'text.primary';
  const subColor = light ? 'rgba(255,255,255,0.75)' : 'text.secondary';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: s.gap }}>
      <img
        src={logo}
        alt={APP_NAME}
        style={{ width: s.logo, height: s.logo }}
      />
      <Box>
        <Typography
          variant={s.name}
          sx={{
            fontWeight: typography.h1.fontWeight,
            letterSpacing: typography.h2.letterSpacing,
            color: textColor,
            lineHeight: typography.h1.lineHeight,
          }}
        >
          {APP_NAME}
        </Typography>
        {subtitle && (
          <Typography
            variant={s.sub}
            sx={{ color: subColor, lineHeight: typography.h3.lineHeight }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default AppHeader;
